import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import styles from './ServiciosHero.module.scss';

const ServiciosHero = () => {
  const { scrollY } = useScroll();
  // Mapea el scroll vertical a un desplazamiento Y para la imagen de fondo
  const backgroundY = useTransform(scrollY, [0, 500], [0, -200]);

  return (
    <div className={styles.hero}>
      {/* Fondo parallax con animación de brillo/opacity */}
      <motion.div
        className={styles.heroBackground}
        style={{ y: backgroundY }}
        initial={{ filter: 'brightness(0.5)', opacity: 0 }}
        animate={{
          filter: ['brightness(0.5)', 'brightness(1.2)', 'brightness(1)'],
          opacity: 1
        }}
        transition={{ duration: 1.5, ease: 'easeInOut' }}
      />

      {/* Texto, estático en scroll (solo sus fades de entrada) */}
      <div className={styles.textSection}>
        <motion.h1
          className={styles.title}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8, ease: 'easeOut' }}
        >
          Nuestros servicios
        </motion.h1>

        <motion.p
          className={styles.subtitle}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8, ease: 'easeOut' }}
        >
          Impulsados por la visión que construye el futuro, en Zoomlion Latinoamérica convertimos la ingeniería en resultados.
        </motion.p>
      </div>
    </div>
  );
};

export default ServiciosHero;
